import React from 'react';
import { graphql } from 'gatsby';
import LitImage from './images/LitImage';
const ModularImageBanner = ({ data }) => {
  const bannerImage = data.bannerImageContent[0].image;
  return (
    <div className="modular-image-banner-container">
      <LitImage
        image={bannerImage}
        alt="banner picture stretching the whole screen"
      />
    </div>
  );
};

export default ModularImageBanner;
export const fragment = graphql`
  fragment ModularImageBanner on DatoCmsBannerImage {
    internal {
      type
    }
    ... on DatoCmsBannerImage {
      id
      bannerImageContent {
        image {
          gatsbyImageData
        }
      }
    }
  }
`;
